import { createStore, combineReducers } from "redux";
import userReducer from "./reducer/userReducer";
import questionReducer from "./reducer/questionReducer";


const reducers = combineReducers({
  userReducer,
  questionReducer,
});

const store = createStore(reducers);


export default store;
